import shadows from '@mui/material/styles/shadows';
export const boxShadow = {
    none: 'none',
    small: shadows[1],
    medium: shadows[5],
    large: shadows[15],
};
